import { SalaryAdvanceValueObjectsRequestStatusEnum } from 'generated/resources/graphql'

import i18n from 'modules/core/lib/i18n'

export type StatusViewerType = 'employee' | 'hr_admin'

/**
 * Get translated label for salary advance request status
 * @param status - The request status from the backend
 * @param viewerType - Who is viewing the status: 'employee' or 'hr_admin'
 *                     HR/admin sees "Pending payment", employees see "Requested"
 */
export const getStatusLabel = (
  status: SalaryAdvanceValueObjectsRequestStatusEnum,
  viewerType: StatusViewerType = 'hr_admin'
): string => {
  switch (status) {
    case 'requested':
      return viewerType === 'employee'
        ? i18n.t('salary_advance.request.status.requested')
        : i18n.t('salary_advance.request.status.requested_hr_admin')
    case 'processing':
      return i18n.t('salary_advance.request.status.processing')
    case 'completed':
      return i18n.t('salary_advance.request.status.completed')
    case 'expired':
      return i18n.t('salary_advance.request.status.expired')
    default: {
      const _exhaustiveCheck: never = status
      throw new Error(`Unhandled status: ${_exhaustiveCheck}`)
    }
  }
}

/**
 * Get visual variant for salary advance request status badge
 * Maps backend status values to OneDataCollection status variants
 * @param status - Backend status: requested, processing, completed, expired
 * @returns Status variant: positive, warning, info, critical, neutral
 */
export const getStatusVariant = (
  status: SalaryAdvanceValueObjectsRequestStatusEnum
): 'positive' | 'warning' | 'info' | 'critical' | 'neutral' => {
  switch (status) {
    case 'completed':
      return 'positive'
    case 'processing':
      return 'info'
    case 'requested':
      return 'warning'
    case 'expired':
      return 'neutral'
    default: {
      const _exhaustiveCheck: never = status
      throw new Error(`Unhandled status: ${_exhaustiveCheck}`)
    }
  }
}
